<template>
    <div
        :class="{
            'card-internship-wrapper': true,
            'card-internship-wrapper--registration-is-closed': isShowClosedReg && !hideStatus,
            'card-internship-wrapper--registration-is-open': isShowOpenReg && !hideStatus,
            'card-internship-wrapper--active': expandedEntityId === internship.id,
        }"
    >
        <div
            :class="{
                'card-internship': true,
                'card-internship--registration-is-open': isShowOpenReg && !hideStatus,
            }"
            @click="goToInternship"
        >
            <div class="card-internship__favorite-btn">
                <FavoriteToggle :entityId="internship.id" entityType="internships" />
            </div>
            <div class="card-internship__wrapper-image">
                <img
                    v-if="internship.bannerSmall || internship.banner"
                    class="card-internship__image"
                    :src="internship.bannerSmall || internship.banner"
                    alt="internship"
                />
                <div class="card-internship__payment" v-if="internship.hasPayment && internship.paymentAmount">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.5 6.5H14C15.3807 6.5 16.5 7.61929 16.5 9C16.5 10.3807 15.3807 11.5 14 11.5H9.5V6.5ZM9.5 6.5V17.5M9.75 11.5H8M13 14.75H8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                            stroke="#251F45"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                <div v-if="!hideStatus">
                    <div
                        class="card-internship__status card-internship__status--opened-registration"
                        v-if="!internship.participantStatus && internship.registrationIsOpen"
                    >
                        <IconOpenedReg />
                        Открыт набор
                    </div>

                    <div
                        class="card-internship__status card-internship__status--closed-registration"
                        v-if="isShowClosedReg"
                    >
                        Закрыт набор
                    </div>

                    <div
                        :class="{
                            'card-internship__status': true,
                            [`card-internship__status--${projectStatus.field_name}`]: true,
                        }"
                        v-if="internship.participantStatus"
                    >
                        {{ projectStatus.field_value }}
                    </div>
                </div>
            </div>
            <div class="card-internship__content">
                <h3 class="card-internship__institute-name">{{ internship.instituteName }}</h3>
                <p class="card-internship__name">{{ internship.name }}</p>
            </div>
            <TagsDropdown
                :entityId="internship.id"
                :expandedEntityId="expandedEntityId"
                :foreignCompetenceIds="internship.competenceIds"
                :foreignCourseAreasId="internship.courseAreaIds"
                @onExpandedTags="$emit('onExpandedTags', internship.id)"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TagsDropdown from './components/TagsDropdown.vue';
import FavoriteToggle from './components/FavoriteToggle.vue';
import IconOpenedReg from '@/views/track/icons/IconOpenedReg.vue';

export default {
    name: 'CardInternship',
    components: {
        FavoriteToggle,
        TagsDropdown,
        IconOpenedReg,
    },
    props: {
        internship: {
            type: Object,
            required: true,
        },
        expandedEntityId: {
            type: [String, Number],
            default: null,
        },

        hideStatus: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('data', ['getRegistryItems']),

        projectStatus() {
            const projectStatus = this.getRegistryItems('stage_history').find(
                (item) => item.id === this.internship.participantStatus
            );

            return projectStatus ? projectStatus : '';
        },

        isShowStatus() {
            return !!this.internship.participantStatus;
        },
        isShowOpenReg() {
            return this.internship.registrationIsOpen && !this.internship.participantStatus;
        },

        isShowClosedReg() {
            return !this.internship.participantStatus && !this.internship.registrationIsOpen;
        },
    },
    methods: {
        goToInternship() {
            window.open(`https://${window.rsvDomain}/internships/1/${this.internship.id}/`, '_blank');
        },
        removeImgTags(text) {
            return text.replace(/<img[^>]*>?/g, '');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.card-internship-wrapper {
    position: relative;
    height: urem(415);
    width: 100%;

    &--active {
        z-index: 2;
    }

    @include on-desktop {
        height: urem(382);
        width: urem(252);
    }
}

.card-internship {
    width: 100%;
    background-color: rgba(255, 255, 255, 1);
    font-size: urem(16);
    font-weight: 400;
    min-height: urem(415);
    color: rgba(42, 38, 38, 1);
    box-shadow: 0 0 urem(20) 0 rgba(70, 99, 171, 0.2);
    position: relative;
    font-family: $font-montserrat;
    display: flex;
    flex-direction: column;
    border-radius: urem(16);
    cursor: pointer;
    z-index: 1;

    &--registration-is-open {
        box-shadow: 0 0 urem(10) 0 rgba(104, 200, 122, 0.8);
    }

    @include on-desktop {
        min-height: urem(382);
        width: urem(252);
    }

    * {
        font-family: inherit;
    }

    &__institute-name {
        font-size: urem(14);
        font-weight: 600;
        color: rgba(70, 99, 171, 1);
        line-height: urem(20);
        margin: 0;
        line-clamp: 1;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;

        @include on-desktop {
            line-clamp: 1;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }

    &__favorite-btn {
        position: absolute;
        top: urem(5);
        right: urem(5);
        z-index: 2;
    }

    &__name {
        margin: 0;
        margin-top: urem(14);
        font-size: urem(14);
        font-weight: 600;
        color: rgba(37, 31, 69, 1);
        line-height: urem(20);
        line-clamp: 2;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;

        @include on-desktop {
            line-clamp: 3;
            -webkit-line-clamp: 3;
        }

        :deep(p) {
            margin: 0;
        }

        :deep(img) {
            display: none;
        }
    }

    &__wrapper-image {
        width: 100%;
        height: urem(188);
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: urem(16);
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        position: relative;

        @include on-desktop {
            height: urem(142);
        }
    }

    &__image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: urem(16);
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    &__content {
        padding: urem(16);

        @include on-desktop {
            padding-bottom: urem(8);
            min-height: urem(122);
        }
    }

    &__payment {
        position: absolute;
        bottom: urem(6);
        right: urem(6);
        width: urem(44);
        height: urem(44);
        background: hsla(0, 0%, 100%, 0.8);
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        @include on-desktop {
            width: urem(32);
            height: urem(32);
        }

        :deep(svg) {
            width: urem(28);
            height: urem(28);
            display: block;

            @include on-desktop {
                width: urem(20);
                height: urem(20);
            }
        }
    }

    &__status {
        display: flex;
        align-items: center;
        gap: urem(6);
        font-size: urem(12);
        font-weight: 600;
        padding: urem(4) urem(8);
        position: absolute;
        top: 0;
        left: 0;
        border-top-left-radius: urem(10);
        border-bottom-right-radius: urem(10);
        height: urem(20);

        background: rgba(236, 239, 247, 1);
        color: rgba(70, 99, 171, 1);

        &--party {
            background: rgba(236, 239, 247, 1);
            color: rgba(70, 99, 171, 1);
        }

        &--half {
            background: rgba(231, 241, 250, 1);
            color: rgba(107, 159, 203, 1);
        }

        &--final {
            background: rgba(217, 215, 231, 1);
            color: rgba(105, 96, 159, 1);
        }

        &--candidate {
            background: rgba(246, 218, 215, 1);
            color: rgba(219, 108, 97, 1);
        }

        &--opened-registration {
            color: white;
            background: rgba(104, 200, 122, 1);

            :deep(svg) {
                width: urem(16);
                height: urem(16);
            }
        }

        &--closed-registration {
            color: white;
            background: rgba(155, 158, 166, 1);
        }
    }
}
</style>
